import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT } from '../../../../constants/service/app/recommendSearchWordConstants';
import { RECOMMEND_SEARCH_WORD_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendSearchWordToastMsg from '../../../../constants/service/toastMsg/recommendSearchWordToastMsg';
import RecommendSearchWordApi from '../../../../lib/api/recommend/searchWord/RecommendSearchWordApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  excelDownLoad,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import { recommendSearchWordActions } from './index';

function* fetchList() {
  /**
   *   추천 검색 키워드 리스트 가져오기
   */
  yield takeEvery(recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.getRecommendSearchWordList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST_SUCCESS);

        const data = {
          recommendSearchWordList: _setResponseListForm(
            result.data.recommendSearchWordList,
            result.data.totalCnt,
            payload,
          ),
        };

        yield put({ type: recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 검색 키워드 상세 요청하기
   */
  yield takeEvery(recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.getRecommendSearchWordDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendSearchWordDetail: {
            recommendSearchWordInfo: result.data.recommendSearchWordInfo,
            recommendSearchWordItemList: result.data.recommendSearchWordItemList,
          },
        };

        yield put({ type: recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 검색 키워드 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendSearchWordActions.PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.prepareCopyRecommendSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST_SUCCESS);

        const data = {
          recommendSearchWordSave: {
            recommendSearchWordInfo: result.data.recommendSearchWordInfo,
            selectedRecommendSearchWordItemList: result.data.selectedRecommendSearchWordItemList,
            recommendSearchWordItemList: _setResponseListForm(
              result.data.recommendSearchWordItemList.list,
              result.data.recommendSearchWordItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendSearchWordActions.PREPARE_COPY_RECOMMEND_SEARCH_WORD_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.PREPARE_COPY_RECOMMEND_SEARCH_WORD_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 검색 키워드 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendSearchWordActions.PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.prepareCreateRecommendSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST_SUCCESS);

        const data = {
          recommendSearchWordSave: {
            recommendSearchWordItemList: _setResponseListForm(
              result.data.recommendSearchWordItemList.list,
              result.data.recommendSearchWordItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendSearchWordActions.PREPARE_CREATE_RECOMMEND_SEARCH_WORD_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.PREPARE_CREATE_RECOMMEND_SEARCH_WORD_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 검색 키워드에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.getRecommendSearchWordItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendSearchWordItemList: _setResponseListForm(
            result.data.recommendSearchWordItemList.list,
            result.data.recommendSearchWordItemList.totalCnt,
            payload,
          ),
        };

        yield put({ type: recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 검색 키워드 등록/복사하기
   */
  yield takeEvery(recommendSearchWordActions.CREATE_RECOMMEND_SEARCH_WORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendSearchWordApi.copyRecommendSearchWord, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendSearchWordToastMsg.CREATE_RECOMMEND_SEARCH_WORD_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_SEARCH_WORD_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendSearchWordToastMsg.CREATE_RECOMMEND_SEARCH_WORD_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 검색 키워드 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendSearchWordActions.GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendSearchWordApi.getRecommendSearchWordItemListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(
            recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS,
          );

          excelDownLoad('검색 키워드 아이템 리스트', result.data.recommendSearchWordItemExcelSheet);
        }
      } catch (error) {
        toastMsg.error(
          recommendSearchWordToastMsg.GET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *   선택된 검색 키워드 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendSearchWordActions.GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendSearchWordApi.getSelectedRecommendSearchWordItemListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(
            recommendSearchWordToastMsg.GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS,
          );

          excelDownLoad('검색 키워드 아이템 리스트', result.data.recommendSearchWordItemExcelSheet);
        }
      } catch (error) {
        toastMsg.error(
          recommendSearchWordToastMsg.GET_SELECTED_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *  검색 키워드 리스트 EXCEL 업로드
   */
  yield takeEvery(
    recommendSearchWordActions.SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendSearchWordApi.setRecommendSearchWordItemListExcelUpload,
          setMultipartForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(
            recommendSearchWordToastMsg.SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS,
          );

          /**
           *  추가하려고 하는 추천 검색 키워드 아이템 개수가 초가되었을 경우
           *  업로드를 하지 못하도록 함
           */
          if (
            result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[payload.recommendSearchWordType]
          ) {
            yield asyncSimpleModal({
              type: 'error',
              title: '아이템 개수 초과',
              message: `추천 검색 키워드 아이템 개수는 최대 ${
                MAXIMUM_NUMBER_OF_RECOMMEND_SEARCH_WORD_ITEM_COUNT[payload.recommendSearchWordType]
              } 입니다.`,
            });
            return;
          }

          yield put({
            type: recommendSearchWordActions.SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_SUCCESS,
            payload: result.data,
          });
        }
      } catch (error) {
        toastMsg.error(
          recommendSearchWordToastMsg.SET_RECOMMEND_SEARCH_WORD_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
